import { FC, ReactNode } from 'react';
import { Breadcrumbs, Container, RoundBackground } from '@/components';
import { Box, Typography } from '@mui/material';
import styles from './styles.module.scss';
import { useTranslation } from 'next-i18next';
import { useOptOutViewModel, Status } from '@/features/optOut/ui/useOptOutViewModel';
import { Form } from '@/components/RequestAccessOptOutForm';
import { EmailConfirm, SendingLetter } from '@/features/optOut/ui/components';
import { ROUTES } from '@/libs/routing';

export const OptOut: FC = () => {
  const { t } = useTranslation('optOut');
  const { currentStatus, handleSubmit, onCaptchaVerifiedChange, captchaValue } =
    useOptOutViewModel();

  const handleCurrentStatus = (status: Status): ReactNode => {
    switch (status) {
      case Status.FORM:
        return (
          <Form
            tNs={'optOut'}
            onSubmit={handleSubmit}
            onCaptchaVerifiedChange={onCaptchaVerifiedChange}
            captchaVerified={!!captchaValue}
          />
        );
      case Status.SENDING:
        return <SendingLetter />;
      case Status.SUCCESS:
        return <EmailConfirm />;
      default:
        return (
          <Form
            tNs={'optOut'}
            onSubmit={handleSubmit}
            onCaptchaVerifiedChange={onCaptchaVerifiedChange}
            captchaVerified={!!captchaValue}
          />
        );
    }
  };
  return (
    <Box className={styles.section}>
      <RoundBackground />
      <Breadcrumbs
        items={[
          {
            label: t('common:header.nav.privacyCenter.title'),
            url: ROUTES.PRIVACY_CENTER,
          },
          { label: t('common:header.nav.optOut.title'), url: ROUTES.OPT_OUT },
        ]}
        classes={{
          container: styles.breadcrumbsContainer,
        }}
      />
      <Container className={styles.container}>
        <Box className={styles.pageDescription}>
          {currentStatus === Status.SUCCESS ? (
            <>
              <Typography variant={'h2'} className={styles.title}>
                {t('titleConfirm')}
              </Typography>
              <Typography variant={'h3'} className={styles.subtitle}>
                {t('subtitleConfirm')}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant={'h2'} className={styles.title}>
                {t('title')}
              </Typography>
              <Typography variant={'h3'} className={styles.subtitle}>
                {t('subtitle')}
              </Typography>
              <Box className={styles.stepsContainer}>
                <Typography variant={'body1'}>{t('steps.first')}</Typography>
                <Typography variant={'body1'}>{t('steps.second')}</Typography>
                <Typography variant={'body1'}>{t('steps.third')}</Typography>
              </Box>
            </>
          )}
        </Box>
        {handleCurrentStatus(currentStatus)}
      </Container>
    </Box>
  );
};
